module.exports = __webpack_public_path__ + "static/img/manual-24.0cc9b81.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-24.png
// module id = P5WQ
// module chunks = 4